import AllPhotos from './AllPhotos';

export default AllPhotos;
